// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] + "-" + {"678":"539b3d9f73907ffbd2e6","883":"2c889db2a020ddc6d0cf"}[chunkId] + ".js";
};